import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Divider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GuideStyles from "assets/js/guide";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

export default function GuideButton() {
  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = panel => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Divider</h2>
          </div>

          <Box>
            <h3 className="guide-h3">Default</h3>
            <Divider />
          </Box>

          <Box mt={12}>
            <h3 className="guide-h3">Color - light #F6F6F6</h3>
            <Divider light />
          </Box>

          <Box mt={12}>
            <h3 className="guide-h3">
              marginLeft: 30px <br />
              marginRight: 30px
            </h3>
            <Divider variant="middle" />
          </Box>

          <Box mt={12}>
            <h3 className="guide-h3">height: 12px</h3>
            <Divider className="divider-type-2" />
          </Box>

          <Accordion
            codemirror={codemirror === "Divider"}
            onChange={handleCodemirror("Divider")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import {
  Divider,
} from "@mui/material";

<Divider />

<Divider light />

<Divider variant="middle" />

<Divider className="divider-type-2" />
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
